const Header = () => {
    return (
      <div className="h1Father">
        <h1>What you are Planning ToDo today</h1>
      </div>
    );
  };
  
  export default Header;